export default {
  title: '',
  login: 'E-mail',
  username: 'Username',
  password: 'Password',
  failed: 'Login attempt unsuccessful',
  submit: 'Submit',
  passwordRequired: 'Password is required',
  incorrectPassword: 'Password is incorrect',
  loginRequired: 'E-mail is required',
  incorrectLogin: 'E-mail format is incorrect',
}
